import { render, staticRenderFns } from "./f-data-item.vue?vue&type=template&id=d90824fc&scoped=true"
import script from "./f-data-item.vue?vue&type=script&lang=js"
export * from "./f-data-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d90824fc",
  null
  
)

export default component.exports